import { Card } from '@ps/isp-web-component-library';
import { Translation } from '@ps/web-shared-components';
import classnames from 'clsx';
import React from 'react';

import { Icon } from '@swf/sports/components';

import { TXTWCL_Show_all_multiples, TXTWCL_Show_less } from './ShowMore.messages.json';
import styles from './ShowMore.scss';

interface Props {
  isExpanded: boolean;
  onToggle(): void;
}

const ShowMore: React.FC<Props> = ({ isExpanded, onToggle }) => (
  <div className={styles.container}>
    {/* DesignSystem: This button does not conform to any rules currently - the fact it looks like a card is
    very odd. Needs looking at. */}
    <Card padded as="button" type="button" onClick={onToggle} className={styles.button}>
      <span className={styles.text}>
        <Translation {...(isExpanded ? TXTWCL_Show_less : TXTWCL_Show_all_multiples)} />
      </span>
      <Icon
        name="chevron-medium-down"
        className={classnames(isExpanded && styles.isExpanded)}
        size="lg"
      />
    </Card>
  </div>
);

export default ShowMore;
